import { All_List_Keys_Client_Website_CMS_Post } from 'api/ApiConst'
import PageHeading from 'components/common/PageHeading'
import PaginationDataTable from 'components/common/PaginationDataTable'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import CMSAddEdit from './CMSAddEdit'
import { PAGE_LOADER } from 'utils/constants'
import { callPostApi } from 'api/ApiCaller'

const CMSMaster = () => {
    const [refreshFlag, setRefreshFlag] = useState(0);
    const [recordID, setRecordID] = useState(null);
    const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);

    const [list, setList] = useState([]);

    useEffect(() => {
        getList();
    }, []);

    const getList = () => {
        callPostApi(PAGE_LOADER, All_List_Keys_Client_Website_CMS_Post, {}, {}, (response) => {
            setList(response.responsePacket);
        });
    };

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);

    const columns = useMemo(
        () => [
            {
                id: "websiteCmsKey",
                name: "Page Type",
                selector: (row) => row,
                sortable: false,
            },
            {
                id: "action",
                name: "",
                selector: (row) => getActionButtons(row),
                width: "80px",
                sortable: false,
            },
        ],
        [handleRefresh]
    );

    const getActionButtons = (row) => {
        return (
            <div className="d-flex align-items-center justify-content-between">
                <button className="listBtn me-2" onClick={() => handleEdit(row)}>
                    <i className="bx bx-pencil"></i>
                </button>
            </div>
        );
    };

    const handleEdit = (row) => {
        setRecordID(row);
        setShowAddUpdateModal(true);
    };

    return (
        <>
            {PageHeading("CMS", "Dashboard", "/")}
            <div className="card">
                <div className="card-body tableView row cms-bg">
                    {list.map((data) => (
                        <div className="col-lg-4" key={data}>
                            <div className="card" style={{ cursor: "pointer" }} onClick={() => handleEdit(data)}>
                                <div className="card-body">
                                    <h5 className="mb-0">{data}</h5>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {showAddUpdateModal && <CMSAddEdit show={showAddUpdateModal} hideModal={() => setShowAddUpdateModal(false)} recordID={recordID} handleRefresh={handleRefresh} />}
        </>
    )
}

export default CMSMaster